class AblyWebSocketPushMessageProvider {
    constructor() {}

    async initialize({ channel, event }) {
        return new Promise((resolve, reject) => {
            touchKit.WebSocketManager.getConnection().then((con) => {
                resolve();
                const messages = con.channels.get(channel);
                messages.subscribe(event, (message) => {
                    app.radio.$emit(event, message);
                });
            });
        });
    }
}
touchKit.PushMessageManager.registerStrategy( "AblyWebSocketPushMessageProvider", () => {
    return new AblyWebSocketPushMessageProvider();
});
